import { memo, useCallback, useState, type MouseEvent } from "react";

import { Button } from "@/components/ui/button/button";
import { RoundedFullButton } from "@/components/ui/button/rounded-full-button";
import Cross from "@/components/ui/icon/cross";
import {
	Table,
	TableBody,
	TableCaption,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table/table";

import { DialogInputGuestInfo } from "./dialog-input-guest-info";
import { useCampaignList } from "../hooks/use-campaign-list";

const AdditionalInfo = memo(() => {
	return (
		<div className="flex flex-col gap-y-1">
			<p className="text-sm">
				※ギフトをメール送信する場合にはCSVに、必ず“名前“、“メールアドレス”を含むヘッダ行を配置してください。“メールアドレス”
				列がない場合、ギフトとそのリンクのみが発行されます。
			</p>
			<span>
				<a
					className="flex cursor-pointer pt-2 text-sm text-link-400 underline-offset-4 hover:underline"
					href="https://editor-assets.chillnn.com/host/%E3%82%AD%E3%82%99%E3%83%95%E3%83%88_%E5%AF%BE%E8%B1%A1%E8%80%85%E3%83%AA%E3%82%B9%E3%83%88%E3%83%86%E3%83%B3%E3%83%95%E3%82%9A%E3%83%AC%E3%83%BC%E3%83%88.csv"
					target="_blank"
					rel="noopener noreferrer"
				>
					テンプレートダウンロード（Macユーザー向け）
				</a>
				<a
					className="flex cursor-pointer pt-2 text-sm text-link-400 underline-offset-4 hover:underline"
					href="https://s3.ap-northeast-1.amazonaws.com/editor-assets.chillnn.com/host/%E3%82%AD%E3%82%99%E3%83%95%E3%83%88_%E5%AF%BE%E8%B1%A1%E8%80%85%E3%83%AA%E3%82%B9%E3%83%88%E3%83%86%E3%83%B3%E3%83%95%E3%82%9A%E3%83%AC%E3%83%BC%E3%83%88_for_windows.csv"
					target="_blank"
					rel="noopener noreferrer"
				>
					テンプレートダウンロード（Windowsユーザー向け）
				</a>
			</span>
		</div>
	);
});

export const MarketingCampaignList = () => {
	const {
		voucherGiftList, //

		canAppendVoucherGiftListItem,
		onAddVoucherGiftListItem,

		onRemoveVoucherGiftListItemByIndex,
	} = useCampaignList();

	const handleClick = useCallback((e: MouseEvent) => {
		e.stopPropagation();
		setOpen(true);
	}, []);

	const handleClickDeleteButton = useCallback(
		(idx: number) => (e: MouseEvent) => {
			e.stopPropagation();
			onRemoveVoucherGiftListItemByIndex(idx);
		},
		[onRemoveVoucherGiftListItemByIndex],
	);

	const [open, setOpen] = useState(false);

	return (
		<div className="flex flex-col gap-y-6">
			<AdditionalInfo />

			<Table>
				<TableCaption>対象者リスト</TableCaption>
				<TableHeader>
					<TableRow>
						<TableHead>No.</TableHead>
						<TableHead>名前</TableHead>
						<TableHead>メールアドレス</TableHead>
						<TableHead>電話番号</TableHead>
						<TableHead>削除</TableHead>
					</TableRow>
				</TableHeader>

				<TableBody>
					{voucherGiftList.value.length ? (
						voucherGiftList.value.map((item, idx) => {
							return (
								<TableRow key={idx}>
									<TableCell className="w-3">{idx + 1}</TableCell>
									<TableCell>{item.guestName.value}</TableCell>
									<TableCell>{item.guestEmail?.value}</TableCell>
									<TableCell>{item.guestTel?.value}</TableCell>
									<TableCell>
										<RoundedFullButton type={"button"} onClick={handleClickDeleteButton(idx)}>
											<Cross />
										</RoundedFullButton>
									</TableCell>
								</TableRow>
							);
						})
					) : (
						<TableRow>
							<TableCell>１</TableCell>
							<TableCell>チルン太郎（サンプル）</TableCell>
							<TableCell>sample@chillnn.com</TableCell>
							<TableCell>00000000000</TableCell>
							<TableCell></TableCell>
						</TableRow>
					)}
				</TableBody>

				<DialogInputGuestInfo open={open} setOpen={setOpen} addItem={onAddVoucherGiftListItem} />
			</Table>

			<div>
				<Button
					variant={canAppendVoucherGiftListItem ? "outline" : "disabled"}
					type={"button"}
					onClick={handleClick}
				>
					ゲストの情報を直接入力する
				</Button>
			</div>
		</div>
	);
};

MarketingCampaignList.displayName = "MarketingCampaignList";
